var _defs, _g, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "120px",
    viewBox: "0 0 400 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientBlue",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60a5fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientGreen",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#34d399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientPurple",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c084fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c3aed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2563eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#059669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7c3aed"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 2,
    floodOpacity: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 60) scale(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-60 L52,-30 L52,30 L0,60 L-52,30 L-52,-30 Z",
    fill: "url(#gradientBlue)",
    opacity: 0.9,
    transform: "translate(-30, -15) rotate(15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-60 L52,-30 L52,30 L0,60 L-52,30 L-52,-30 Z",
    fill: "url(#gradientGreen)",
    opacity: 0.9,
    transform: "translate(30, -15) rotate(-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-60 L52,-30 L52,30 L0,60 L-52,30 L-52,-30 Z",
    fill: "url(#gradientPurple)",
    opacity: 0.9,
    transform: "translate(0, 30)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "white",
    stroke: "#f5f5f5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#374151"
  }, "3T"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fontWeight: "bold",
    fill: "url(#textGradient)"
  }, "THREETRY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 90,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#4b5563"
  }, "Innovative Intermediary Services")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreetry);
export default __webpack_public_path__ + "static/media/Threetry.b8e5c5cf55dc3e10b1a5a7782d3f9ef6.svg";
export { ForwardRef as ReactComponent };